import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "./Reveal";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-upland-offwhite py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-upland-brown mb-5">What clients say</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight text-upland-green max-w-2xl leading-tight">
            Trusted by the leaders we partner with.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.1}>
              <figure data-testid={`testimonial-${i}`} className="h-full bg-upland-creme border border-upland-brown/15 p-8 flex flex-col">
                <Quote size={32} className="text-upland-brown/40 mb-5" />
                <blockquote className="text-upland-green text-lg leading-relaxed flex-1">"{t.quote}"</blockquote>
                <figcaption className="mt-6 pt-5 border-t border-upland-brown/20">
                  {t.author && <span className="block font-serif text-lg text-upland-green">{t.author}</span>}
                  <span className="block text-sm text-upland-brown">
                    {[t.title, t.company].filter(Boolean).join(", ")}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
